import MapRoot from "./MapRoot";
import MapDisplay from "./MapDisplay";
import MapFooter from "./MapFooter";
import MapButton from "./MapButton";
import Draw from "./MapDraw";
import MapHeat from "./MapHeat";
import MapLocalization from "./MapLocalization";

const Map = {
  Root: MapRoot,
  Display: MapDisplay,
  Draw: Draw,
  Localization: MapLocalization,
  Heatmap: MapHeat,
  Footer: MapFooter,
  Button: MapButton,
};

export default Map;
